import { Navigate, Route, Routes } from 'react-router';
import { RequireAuth } from '@/app/guards/RequireAuth';
import { AppShell } from '@/app/layouts/AppShell';
import { LoginScreen } from '@/routes/auth/LoginScreen';
import { AuthCallbackScreen } from '@/routes/auth/AuthCallbackScreen';
import { BoardScreen } from '@/features/board/BoardScreen';
import { AdminScreen } from '@/features/admin/AdminScreen';
import { RequireAdmin } from '@/app/guards/RequireAdmin';

export function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<LoginScreen />} />
      <Route path="/auth/callback" element={<AuthCallbackScreen />} />

      <Route
        path="/"
        element={
          <RequireAuth>
            <AppShell />
          </RequireAuth>
        }
      >
        <Route index element={<Navigate to="/board" replace />} />
        <Route path="board" element={<BoardScreen />} />
        <Route
          path="admin"
          element={
            <RequireAdmin>
              <AdminScreen />
            </RequireAdmin>
          }
        />
      </Route>

      <Route path="*" element={<Navigate to="/board" replace />} />
    </Routes>
  );
}
